<!--start section header-->
 
<header class="head">
    <div class="cover">
        <div class="container d-flex justify-content-center align-items-center pt-5">
         <div>
             <h2 class="pt-5">
                Management
             </h2>
             <nav aria-label="breadcrumb">
                 <ol class="breadcrumb d-flex justify-content-center">
                   <li (click) = change() class="breadcrumb-item">
                       <a>Home</a>
                     </li>
                   <li class="breadcrumb-item active" aria-current="page">Management</li>
                 </ol>
             </nav>
         </div>
 
        </div>
    </div>
 
 </header>
 
 <!--end section header-->


  <!--start section Product-->

<section class="py-5 container team">
    <div class="row pt-5 pb-4">


        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/2.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Duane Garza
                      <p>Pharmacist</p>
                  </h5>
                  <p class="card-text">Tongue alcatra spare ribs shankle bacon. <br>
                     Ham hock cupim sirloin, jerky tongue <br>
                      porchetta.
                  </p>
                  <div class="d-felx justify-content-around icons">
                    <i class="fab fa-facebook-f pr-3"></i>
                    <i class="fab fa-twitter pr-3"></i>
                    <i class="fab fa-google"></i>
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/4.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Leila Mann
                    <p>Pharmacist</p>
                  </h5>
                  <p class="card-text">Pork belly kevin ball tip venison, pig <br>
                     porchetta salami ground round. Short <br>
                      loin sirloin jerky salami
                  </p>
                  <div class="d-felx justify-content-around icons">
                    <i class="fab fa-facebook-f pr-3"></i>
                    <i class="fab fa-twitter pr-3"></i>
                    <i class="fab fa-google"></i>
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/6.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Tony Wilson
                    <p>Pharmacist</p>
                  </h5>
                  <p class="card-text">Spare ribs kielbasa beef ribs doner <br>
                     leberkas meatball alcatra kevin jerky <br>
                      boudin cow shankle
                  </p>
                  <div class="d-felx justify-content-around icons">
                    <i class="fab fa-facebook-f pr-3"></i>
                    <i class="fab fa-twitter pr-3"></i>
                    <i class="fab fa-google"></i>
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/7.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Duane Garza
                    <p>Pharmacist</p>
                  </h5>
                  <p class="card-text">Tenderloin pork leberkas shankle, <br>
                     drumstick pastrami jerky biltong tail <br>
                      porchetta picanha venison.
                  </p>
                  <div class="d-felx justify-content-around icons">
                    <i class="fab fa-facebook-f pr-3"></i>
                    <i class="fab fa-twitter pr-3"></i>
                    <i class="fab fa-google"></i>
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/8.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Leila Mann
                    <p>Pharmacist</p>
                  </h5>
                  <p class="card-text">Turducken meatball pastrami turkey strip <br>
                     steak prosciutto. Chicken meatball pork <br>
                      belly.
                 </p>
                 <div class="d-felx justify-content-around icons">
                    <i class="fab fa-facebook-f pr-3"></i>
                    <i class="fab fa-twitter pr-3"></i>
                    <i class="fab fa-google"></i>
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/9.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Tony Wilson
                    <p>Pharmacist</p>
                  </h5>
                  <p class="card-text">Ball tip tenderloin jerky shank drumstick <br>
                     spare ribs frankfurter pork belly alcatra <br>
                      tongue.
                  </p>
                  <div class="d-felx justify-content-around icons">
                    <i class="fab fa-facebook-f pr-3"></i>
                    <i class="fab fa-twitter pr-3"></i>
                    <i class="fab fa-google"></i>
                  </div>
                </div>
              </div>
        </div>

    </div>

</section>

<!--end section Product-->